import GraphQL from "../../api/graphql";
import isEmpty from "lodash/isEmpty";
import { make } from "vuex-pathify";

const state = {
    id: null,
    favoriteLists: [],
    term: "",
    name: "",
    isPrivate: "",
    favoriteListOption: ""
};

const mutations = make.mutations(state);

const actions = {
    async fetch({ state, rootState }) {
        const currentPage = state.currentPage;
        const term = state.term;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                    {
                        favoriteLists{
                            id
                            name: title
                            private: is_private
                        }
                    }
            `,
            variables: {
                currentPage,
                term
            }
        });

        const favoriteLists = response.data.favoriteLists.map(favoriteList => {
            favoriteList.private = favoriteList.private ? "Sim" : "Não";

            return favoriteList;
        });

        this.set("favoriteList/favoriteLists", favoriteLists);
    },
    reset() {
        this.set("favoriteList/favoriteLists", []);
        this.set("favoriteList/term", "");
        this.set("favoriteList/id", null);
        this.set("favoriteList/name", "");
        this.set("favoriteList/isPrivate", "");
    },
    async createFavoriteList({ dispatch, rootState, state }) {
        const { name, isPrivate } = state;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const visibility = isPrivate === "Y" ? "PRIVATE" : "PUBLIC";

        await client.query({
            query: `
                mutation($title: String!, $visibility: Visibility!) {
                    createFavoriteList(title: $title, visibility: $visibility) {
                        id
                    }
                }
            `,
            variables: {
                title: name,
                visibility
            }
        });

        await dispatch("fetch");
        this.set("favoriteList/name", "");
        this.set("favoriteList/isPrivate", "");
    },

    async deleteFavoriteList({ dispatch, rootState }, id) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($id: ID!) {
                    deleteFavoriteList(id: $id) {
                        id
                    }
                }
            `,
            variables: {
                id
            }
        });

        await dispatch("fetch");
    },

    async updateFavoriteList({ dispatch, rootState, state }) {
        const { id, name, isPrivate } = state;

        if (isEmpty(id) || isEmpty(name) || isEmpty(isPrivate)) {
            throw new Error("Todos os campos são obrigatórios");
        }

        const visibility = isPrivate === "Y" ? "PRIVATE" : "PUBLIC";

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($id: ID!, $title: String, $visibility: Visibility) {
                    updateFavoriteList(id: $id, title: $title, visibility: $visibility) {
                        id
                    }
                }
            `,
            variables: {
                id,
                title: name,
                visibility
            }
        });

        await dispatch("fetch");
        this.set("favoriteList/id", null);
        this.set("favoriteList/name", "");
        this.set("favoriteList/isPrivate", "");
    },

    async fetchFavoriteList({ rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                {
                    favoriteLists {
                        id
                        name: title
                    }
                }
            `,
            variables: {}
        });

        this.set(
            "favoriteList/favoriteListOption",
            response.data.favoriteLists
        );
    }
};

export default { state, mutations, actions };
